<template>
  <generic-modal
    size="small"
    :title="$t('robocredit configuration')"
    icon="settings"
    image="/images/icons/robocredit.png"
    v-bind:scrolling="false"
    v-on:destroy="destroy"
    :on_finished="finished"
  >
    <div class="description">
      <div class="ui form">
        <div class="ui top attached two item tabular menu" ref="tabs">
          <a class="active item" data-tab="new_customers">
            <i class="user icon"></i> {{ $t("new customers") }}</a
          >
          <a class="item" data-tab="existing_customers">
            <i class="users icon"></i> {{ $t("existing customers") }}</a
          >
        </div>
        <div
          class="ui bottom attached active tab segment"
          data-tab="new_customers"
        >
          <div class="field">
            <label for>{{ $t("process public key") }}</label>
            <textarea
              name="process_key"
              v-model="setup.process_key"
              rows="2"
            ></textarea>
          </div>
          <div class="field">
            <label for>{{ $t("process starter path") }}</label>
            <input type="text" name="starter_path" v-model="setup.soc1_path" />
          </div>
          <div class="field">
            <label for>{{ $t("automated users") }}</label>
            <input
              type="text"
              name="automated_users"
              v-model="setup.automated_users"
            />
          </div>
          <div class="field">
            <label for>{{
              $t("robocredit api host (including port if needed)")
            }}</label>
            <input
              type="text"
              name="modul_api_url"
              v-model="setup.robocredit_api_host"
            />
          </div>
          <div class="field">
            <label for>{{
              $t("electronic formalization api host (including port if needed)")
            }}</label>
            <input
              type="text"
              name="formalization_api_url"
              v-model="setup.formalization_api_host"
            />
          </div>
        </div>
        <div
          class="ui bottom attached tab segment"
          data-tab="existing_customers"
        >
          <div class="field">
            <label for>{{ $t("process public key") }}</label>
            <textarea
              name="process_key"
              v-model="setup.existing_users_initiator.process_key"
              rows="2"
            ></textarea>
          </div>
          <div class="field">
            <label for>{{ $t("process starter path") }}</label>
            <input
              type="text"
              name="starter_path"
              v-model="setup.existing_users_initiator.initiator_path"
            />
          </div>
          <div class="field">
            <label for>{{ $t("automated users") }}</label>
            <input
              type="text"
              name="automated_users"
              v-model="setup.existing_users_initiator.automated_users"
            />
          </div>
        </div>
      </div>
    </div>
  </generic-modal>
</template>

<script>
import { local_api, error_toast } from "@/utils";
import GenericModal from "@/components/GenericModal";

export default {
  name: "NvidiaBundleConfigurationModal",
  components: {
    "generic-modal": GenericModal,
  },
  computed: {},
  data() {
    return {
      setup: {
        process_key: "",
        soc1_path: "",
        automated_users: "",
        robocredit_api_host: "",
        formalization_api_host: "",
        existing_users_initiator: {
          process_key: "",
          initiator_path: "",
          automated_users: "",
        },
      },
    };
  },
  methods: {
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
    init() {
      let vm = this;
      local_api(vm, "post", "/robocredit/configuration/do-get")
        .then((conf) => {
          if (conf) {
            if (conf)
              if (!conf.existing_users_initiator)
                conf.existing_users_initiator = {};
            vm.setup = conf;
          }

          window.jQuery(vm.$refs.tabs).find(".item").tab();
        })
        .catch((err) => {
          error_toast(err);
        });
    },
    finished() {
      let vm = this;
      return new Promise(function (resolve, reject) {
        local_api(vm, "post", "/robocredit/configuration/do-save", {
          s: vm.setup,
        })
          .then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
  mounted() {
    let vm = this;
    vm.init();
  },
  watch: {},
  updated: function () {},
};
</script>
